import React from "react"

import { FormControl, FormHelperText, FormLabel, Box } from "@mui/joy";
import { Controller } from "react-hook-form";
import { useTranslation } from 'react-i18next';

const InputIconSelector = (props) => {
    const { t } = useTranslation();

    const { editing, required, name, control, label, autoFocus, placeholder, hint, icon, haserror, disabled, minrows, className = "" } = props
    let { readonly } = props;
    if (!editing) readonly = true;

    let generalClass = "form-element-control";
    generalClass += (editing) ? " editing" : " reading";
    generalClass += (haserror) ? " error" : "";
    generalClass += (required) ? " required" : "";
    generalClass += (disabled) ? " disabled" : "";
    generalClass += (readonly) ? " readonly" : "";

    return (
        <Controller
            name={name}
            control={control}
            render={({
                field: { onChange, value, name },
                fieldState: { error, invalid },
                formState,
            }) => (
                <div className={("form-element iconSelector " + className).trim()}>
                    <FormControl error={invalid} className={(error) ? generalClass + " form-element-error" : generalClass}>
                        <FormLabel className="form-element-label" htmlFor={name}>{t(label)}</FormLabel>
                        <Box className="iconOptions">
                            {
                                props.options && props.options.map((option, k) => (
                                    <Box key={k} className={value === option.value ? "iconOption iconOptionSelected" : "iconOption"}>
                                        <input
                                            type="radio"
                                            id={`${name}-${option.value}`}
                                            name={name}
                                            value={option.value}
                                            checked={value === option.value}
                                            onChange={() => onChange(option.value)}
                                            className="hidden"
                                        />
                                        <label
                                            htmlFor={`${name}-${option.value}`}
                                            className={`inline-flex items-center cursor-pointer p-2 border-2 rounded-lg ${value === option.value
                                                ? 'border-blue-500 bg-blue-50'
                                                : 'border-gray-300 hover:border-gray-400'
                                                }`}
                                        >
                                            <img
                                                src={option.value}
                                                alt={option.label}
                                                className="w-8 h-8 mr-2"
                                            />
                                            <span>{option.label}</span>
                                        </label>
                                    </Box>
                                ))
                            }
                        </Box>
                        <FormHelperText className="form-element-hint">
                            {(haserror || error) ? (
                                <>
                                    {error ? error.message : 'Messaggio di errore'}
                                </>
                            ) : (
                                <>
                                    {hint}
                                </>
                            )}
                        </FormHelperText>
                    </FormControl>
                </div>
            )}
        />
    );
};


export default InputIconSelector;
